import { type Column } from '../../components/feedback';
import { ReportList } from './ReportList';

interface AuditRow {
  id: string;
  actorId: string | null;
  actorRole: string | null;
  tenantId: string | null;
  action: string;
  entity: string | null;
  entityId: string | null;
  ipAddress: string | null;
  createdAt: string;
}

const when = (iso: string) =>
  new Date(iso).toLocaleString('en-IN', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });

const columns: Column<AuditRow>[] = [
  { key: 'when', header: 'When', render: (r) => <span className="text-muted text-sm">{when(r.createdAt)}</span> },
  { key: 'action', header: 'Action', render: (r) => <span className="font-medium">{r.action}</span> },
  { key: 'actor', header: 'Actor', render: (r) => <span className="text-muted text-sm">{r.actorId ?? 'system'}</span> },
  { key: 'role', header: 'Role', render: (r) => <span className="text-muted text-sm">{r.actorRole ?? '—'}</span> },
  {
    key: 'entity',
    header: 'Target',
    render: (r) => (
      <span className="text-muted text-sm">
        {r.entity ?? '—'}{r.entityId ? ` · ${r.entityId}` : ''}
      </span>
    ),
  },
  { key: 'ip', header: 'IP', render: (r) => <span className="text-muted text-sm">{r.ipAddress ?? '—'}</span> },
];

export function AdminAuditLogPage() {
  return (
    <ReportList<AuditRow>
      title="Audit Log"
      subtitle="Who did what, and from where"
      endpoint="/api/admin/audit-logs"
      searchPlaceholder="Search action or actor id…"
      columns={columns}
      emptyText="No audit entries yet."
      csv={{
        filename: 'audit-log.csv',
        header: ['When', 'Action', 'Actor', 'Role', 'Entity', 'Entity id', 'IP'],
        toRow: (r) => [r.createdAt, r.action, r.actorId, r.actorRole, r.entity, r.entityId, r.ipAddress],
      }}
    />
  );
}